import { Component, inject, input, output, resource } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { DocumentLmaCard } from '../document-lma-card/document-lma-card';
import { Api } from '../../../../core/clients/omni-core/api';
import { listFiles, ListFiles$Params } from '../../../../core/clients/omni-core/functions';
import { FileListResponse } from '../../../../core/clients/omni-core/models';
import { TranslocoPipe } from '@jsverse/transloco';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { DocumentLmaCardSkeleton } from '../document-lma-card-skeleton/document-lma-card-skeleton';
import { NotImplementedDirective } from '../../../../shared/directives/not-implemented';

@Component({
  selector: 'app-document-lma-card-list',
  imports: [
    Button,
    NgIcon,
    DocumentLmaCard,
    TranslocoPipe,
    ErrorComponent,
    DocumentLmaCardSkeleton,
    NotImplementedDirective,
  ],
  templateUrl: './document-lma-card-list.html',
})
export class DocumentLmaCardList {
  private api = inject(Api);

  organizationID = input.required<string>();

  clickOpen = output<string>();

  protected lma = resource<FileListResponse, ListFiles$Params>({
    params: () => ({
      oid: this.organizationID(),
      limit: 100,
      orderBy: 'createdAt',
      orderDirection: 'desc',
      fileType: [
        'LMA_BATTERY_SIMULATION',
        'LMA_GRID_USAGE_OPTIMIZATION',
        'LMA_LOAD_SIMULATION',
        'LMA_LOCATION_ANALYSIS',
        'LMA_OTHER',
      ],
    }),
    loader: ({ params }) => this.api.invoke(listFiles, params),
  });
}
